import { Component } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-faqs',
  imports: [],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss'
})
export class FaqsComponent {

  constructor(private readonly router: Router) {}

  navigateHome() {
    this.router.navigate(['/']);
  }

}
